import { api } from '../api'
import { IChangePassword, ITokens, ServerResponse } from '../../models/models'

interface ISignIn {
	email: string
	password: string
}

export const authApi = api.injectEndpoints({
	endpoints: (builder) => ({
		signIn: builder.mutation<ITokens, ISignIn>({
			query: (body) => ({
				url: 'tokens',
				method: 'POST',
				body,
			}),
			invalidatesTags: ['currentUser'],
			transformResponse: (response: ServerResponse<ITokens>) => response.data,
		}),
		signOut: builder.mutation<any, any>({
			query: () => ({
				url: 'tokens/revoke',
				method: 'POST',
			}),
		}),
		sendResetPasswordLink: builder.mutation<any, { callbackUrl: string; email: string }>({
			query: (body) => ({
				url: 'password/reset/link',
				method: 'POST',
				body,
			}),
		}),
		changePassword: builder.mutation<ITokens, IChangePassword>({
			query: (body) => ({
				url: 'password/reset',
				method: 'POST',
				body,
			}),
			invalidatesTags: ['currentUser'],
			transformResponse: (response: ServerResponse<ITokens>) => response.data,
		}),
	}),
})

export const { useSignInMutation, useSignOutMutation, useSendResetPasswordLinkMutation, useChangePasswordMutation } = authApi
